import enUS from 'antd/locale/en_US';
import esES from 'antd/locale/es_ES';
import zhCN from 'antd/locale/zh_CN';
import itIT from 'antd/locale/it_IT';

export function getAntdLocale(locale) {
  const language = locale.toLowerCase().split('-')[0];

  switch (language) {
    case 'es':
      return esES;
    case 'zh':
      return zhCN;
    case 'it':
      return itIT;
    default:
      return enUS;
  }
}
